import { useEffect } from 'react';

import { getCache } from 'core/cache';
import { useQueryClient } from '@tanstack/react-query';

const LEGACY_KEYS = {
  currentProfile: 'user',
  learnerSettings: 'settings',
};

export default ({ isEnabled, queryKey }) => {
  const { data, status } = useQueryClient().getQueryState(queryKey);
  const key = queryKey[0];

  useEffect(() => {
    if (!isEnabled) return;

    const cache = getCache(LEGACY_KEYS[key] || key);

    cache.set(data);
    cache.setStatus(status);
  }, [data, isEnabled, key, status]);
};
